import ProgressLine from './ProgressLine.vue'

export interface Props {
  steps: number
  current: number
}

export default ProgressLine